<template>
  <!-- eslint-disable -->
  <div class="quiz-item">
    <va-tinymce-input
      ref="tinymce"
      class="mb-4 w-full"
      :current-content="node.data.content"
      :editor-height="120"
      title="Content"
      :forced-root-block-attrs="{ class: 'quiz-question-content' }"
      auto-resize
      @update="content => updateQuestionContent(content)" />
    <v-btn v-if="displayAddAnswerBtn" @click="addAnswer">Add answer</v-btn>
  </div>
</template>

<script>
  import { ANSWER } from "./constant";
  import cloneDeep from "lodash/cloneDeep";

  /* eslint-disable */
  export default {
    name: "QuizQuestion",
    props: {
      node: {
        type: Object,
        required: true,
      },
      tree: {
        type: Object,
        required: true,
      },
    },
    computed: {
      displayAddAnswerBtn() {
        if (this.node.data.type === "question") return true;

        return false;
      },
    },
    methods: {
      addAnswer() {
        this.tree.addNode(this.node, cloneDeep(ANSWER));
      },
      updateContent(content) {
        if (this.$refs.tinymce) {
          this.$refs.tinymce.updateContent(content);
        }
      },
      updateQuestionContent(content) {
        this.node.data.content = content;
      },
    },
  };
</script>

<style lang="scss" scoped></style>
